<template>
  <div class="col-sm-6">
    <h2 class="text-center char-header">
      <strong>{{ character.name }}</strong>
    </h2>
    <div class="character text-center">
      <select
        class="player-select"
        v-model="playerSelected"
        v-if="type == 'player'"
      >
        <option
          v-for="playerImg in playerImages"
          :key="playerImg.value"
          :value="playerImg.value"
          >{{ playerImg.text }}</option
        >
      </select>
      <img :class="type" :src="selectedImage" />
    </div>
    <Healthbar :character="character"></Healthbar>
  </div>
</template>

<script>
import Healthbar from "./Healthbar.vue";

export default {
  name: "Character",
  components: { Healthbar },
  props: {
    character: {
      type: Object,
      required: true
    },
    type: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      playerImages: [
        {
          value: "archon",
          text: "Archon",
          image: "/img/monster_slayer/characters/archon.gif"
        },
        {
          value: "firemage",
          text: "Fire Mage",
          image: "/img/monster_slayer/characters/firemage.gif"
        },
        {
          value: "scion",
          text: "Scion",
          image: "/img/monster_slayer/characters/scion.gif"
        },
        {
          value: "warlock",
          text: "Warlock",
          image: "/img/monster_slayer/characters/warlock.gif"
        }
      ],
      monsterImages: [
        {
          value: "demon",
          text: "Demon",
          image: "/img/monster_slayer/characters/demon.gif"
        }
      ],
      playerSelected: "warlock",
      monsterSelected: "demon"
    };
  },

  computed: {
    selectedImage() {
      return this.getImageURL();
    }
  },

  methods: {
    getImageURL() {
      let images = [];
      let name = "";
      let result = "";

      if (this.type == "player") {
        images = this.playerImages;
        name = this.playerSelected;
      } else {
        images = this.monsterImages;
        name = this.monsterSelected;
      }

      images.forEach(element => {
        if (element.value == name) {
          result = element.image;
        }
      });

      return result;
    }
  }
};
</script>